import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { MOBILE_RECOMMENDATION_COUNT } from '../constants';
import { Card } from './Card';
const SKELETON_CARD_KEYS = Array.from({
  length: MOBILE_RECOMMENDATION_COUNT
}, (_, index) => `skeleton-card-${index + 1}`);
export function Skeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul id="mobile-recommendations-cards" role="status" aria-live="polite" aria-busy="true" aria-label="Loading recommendations" className={css({
      display: "flex",
      flexDirection: "row",
      gap: {
        base: "2",
        sm: "3"
      },
      justifyContent: {
        base: "space-evenly",
        sm: "flex-start"
      },
      pb: "3",
      overflowX: "auto",
      listStyle: "none",
      padding: "0",
      margin: "0"
    })}>{SKELETON_CARD_KEYS.map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(key) {
  return <li key={key} className={css({
    display: "flex",
    flex: "1",
    minWidth: "[0]"
  })}><Card /></li>;
}